import { Injectable } from '@angular/core';
import { ApiService, AppSettingsService } from '@woolworthsnz/styleguide';
import { ProductCarousel } from '@woolworthsnz/trader-api';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ProductCarouselService {
	constructor(
		private apiService: ApiService,
		private appSettingsService: AppSettingsService
	) {}

	getMyFavouritesPastOrdersProductForCarousel(): Observable<ProductCarousel> {
		return this.apiService.get(this.appSettingsService.getEndpoint('productCarousel'));
	}
}
